<template>
  <div class="rating-popup">
    <!-- 评价表单 -->
    <div v-show="!resultVisible" class="rating-content">
      <div class="rating-header">
        <h3 class="rating-title">{{ $t('chatWidget.rating.title') }}</h3>
      </div>

      <div class="rating-body">
        <!-- 评价选项 -->
        <div class="rating-options">
          <div
            :class="['rating-option', { 'selected': selected === 'satisfied' }]"
            @click="selectOption('satisfied')"
          >
            <span class="emoji">😊</span>
            <span class="label">{{ $t('chatWidget.rating.satisfied') }}</span>
          </div>

          <div
            :class="['rating-option', { 'selected': selected === 'dissatisfied' }]"
            @click="selectOption('dissatisfied')"
          >
            <span class="emoji">😞</span>
            <span class="label">{{ $t('chatWidget.rating.dissatisfied') }}</span>
          </div>
        </div>

        <!-- 建议输入框 -->
        <div class="rating-comment">
          <el-input
            type="textarea"
            :rows="4"
            resize="none"
            :maxlength="50"
            show-word-limit
            :placeholder="$t('chatWidget.rating.placeholder')"
            v-model="dataForm.remark"
          />
        </div>

        <!-- 操作按钮 -->
        <div class="rating-actions">
          <el-button
            type="primary"
            class="submit-btn"
            @click="submit"
            :disabled="!selected"
          >
            {{ $t('chatWidget.rating.submit') }}
          </el-button>
          <el-button class="action-btn" @click="submitEnd">
            {{ $t('chatWidget.rating.endChat') }}
          </el-button>
          <el-button class="action-btn" @click="submitCancel">
            {{ $t('chatWidget.rating.backToChat') }}
          </el-button>
        </div>
      </div>
    </div>

    <!-- 提交成功界面 -->
    <div v-show="resultVisible" class="rating-success">
      <div class="success-icon">✓</div>
      <p class="success-message">{{ $t('chatWidget.rating.success') }}</p>
      <el-button
        type="primary"
        class="success-btn"
        @click="closeSuccess"
      >
        {{ $t('chatWidget.rating.endChat') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { evaluation } from '@/common/imCilent';

export default {
  name: 'ImRate',
  props: {
    groupId: {
      type: String,
      default: ''
    },
    dataItem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      resultVisible: false,
      dataForm: {
        rate: null,
        remark: '',
        groupUniqueId: '',
        reply: 1,
        imMessageSessionId: ''
      },
      selected: null
    };
  },
  methods: {
    init() {
      this.resultVisible = false;
      this.dataForm.rate = null;
      this.dataForm.remark = '';
      this.selected = null;
    },

    selectOption(option) {
      this.selected = option;
    },

    submit() {
      if (!this.selected) {
        this.$message.warning('请选择评价选项');
        return;
      }

      // 设置评分
      this.dataForm.rate = this.selected === 'satisfied' ? 1 : 0;
      this.dataForm.groupUniqueId = this.groupId;

      // 获取消息会话ID
      if (this.dataItem) {
        this.dataForm.imMessageSessionId = this.dataItem.imMessageSessionId || '';
      }

      // 调用评价接口
      evaluation(this.dataForm).then(res => {
        if (res.code === 200) {
          this.resultVisible = true;
          this.$emit('custom-event', { item: this.dataItem, num: 1 });
          setTimeout(() => {
            this.init();
          }, 2000);
        } else {
          this.$message.error('评价提交失败，请重试');
        }
      }).catch(err => {
        console.error('评价提交失败:', err);
        this.$message.error('评价提交失败，请重试');
      });
    },

    submitEnd() {
      this.$emit('end-chat');
      this.init();
    },

    submitCancel() {
      this.$emit('back-chat');
      this.init();
    },

    closeSuccess() {
      this.$emit('end-chat');
      this.init();
    }
  }
};
</script>

<style lang="less" scoped>
.rating-popup {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 380px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  animation: slideUp 0.3s ease;
  z-index: 10001;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.rating-content {
  padding: 28px 24px;
}

.rating-header {
  margin-bottom: 24px;
}

.rating-title {
  font-size: 22px;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
  text-align: center;
}

.rating-body {
  .rating-options {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
  }

  .rating-option {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 16px;
    border-radius: 12px;
    background: #f7fafc;
    border: 2px solid transparent;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #edf2f7;
    }

    &.selected {
      background: #134176;
      border-color: #134176;

      .emoji {
        transform: scale(1.1);
      }

      .label {
        color: white;
      }
    }

    .emoji {
      font-size: 36px;
      margin-bottom: 10px;
      transition: transform 0.2s ease;
    }

    .label {
      font-size: 15px;
      font-weight: 500;
      color: #718096;
      transition: color 0.2s ease;
    }
  }

  .rating-comment {
    margin-bottom: 24px;

    ::v-deep .el-textarea {
      .el-textarea__inner {
        border-radius: 8px;
        border: 1px solid #e2e8f0;
        padding: 14px 18px;
        font-size: 15px;
        resize: none;

        &:focus {
          border-color: #134176;
        }
      }
    }
  }

  .rating-actions {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .submit-btn,
  .action-btn {
    padding: 11px 18px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
  }

  .submit-btn {
    background: #134176;
    border-color: #134176;
    color: white;

    &:hover:not(:disabled) {
      background: #0f3059;
      border-color: #0f3059;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .action-btn {
    background: white;
    border: 1px solid #e2e8f0;
    color: #718096;

    &:hover {
      border-color: #134176;
      color: #134176;
    }
  }
}

.rating-success {
  padding: 48px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 280px;

  .success-icon {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: #48bb78;
    color: white;
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    animation: scaleIn 0.3s ease;
  }

  @keyframes scaleIn {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }

  .success-message {
    font-size: 20px;
    font-weight: 600;
    color: #2d3748;
    margin: 0 0 32px 0;
  }

  .success-btn {
    width: 100%;
    padding: 14px;
    background: #134176;
    border-color: #134176;
    color: white;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;

    &:hover {
      background: #0f3059;
      border-color: #0f3059;
    }
  }
}
</style>
